import ReducerRegistry from '../base/redux/ReducerRegistry';
import logger from './logger';
logger.info("Six15 reducer running code:");
import { SCREEN_OVERLAY, SCREEN_SHOT, } from './actionTypes';
import { ENDPOINT_MESSAGE_RECEIVED } from '../base/conference/actionTypes';
const DEFAULT_STATE = {
    six15_payload: "test"
};
/**
 * Reduces the Redux actions of the feature features/six15.
 */
//Not works
ReducerRegistry.register('features/six15', (state = DEFAULT_STATE, action) => {
    // logger.info("Reducer from features/six15 called: " + action.type);
    switch (action.type) {
        case SCREEN_OVERLAY: {
            //Local change to the UI
            const { six15_payload } = action;
            // logger.info("Reducer from features/six15 called for SCREEN_OVERLAY: Payload:" + six15_payload + " keys:" + Object.keys(action))
            return {
                ...state,
                six15_payload
            };
            break;
        }
        case SCREEN_SHOT: {
            //Local change to the UI
            const { six15_payload } = action;
            // logger.info("Reducer from features/six15 called for SCREEN_SHOT: Payload:" + six15_payload + " keys:" + Object.keys(action))
            return {
                ...state,
                six15_payload
            };
            break;
        }
        case ENDPOINT_MESSAGE_RECEIVED: {
            //Remote change from other client
            const { data } = action;
            if (data.type != SCREEN_OVERLAY && data.type != SCREEN_SHOT) {
                return state;
            }
            // logger.info("Saw Json:"+data+" keys:"+Object.keys(data))
            const { six15_payload } = data;
            // logger.info("Reducer from features/six15 called for ENDPOINT_MESSAGE_RECEIVED: Payload:" + six15_payload + " keys:" + Object.keys(action))
            return {
                ...state,
                six15_payload
            };
            break;
        }
    }
    return state;
});
